// extracted by mini-css-extract-plugin
export var circle = "_dx-1";
export var exitConfirmationModal = "_dx-5";
export var iframe = "_dx-0";
export var offline = "_dx-3";
export var online = "_dx-2";
export var workstationSelectError = "_dx-4";